import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

import store from './redux/store';
import App from './App';

import 'antd/dist/antd.min.css';
import './scss/app.scss';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>,
);

console.log(`Score: 165/200
ВНИМАНИЮ ПРОВЕРЯЮЩЕМУ! Я немного отошёл от ТЗ, при этом все изменения описаны ниже. Спасибо за проверку.
1. Главная страница содержит все товары магазина а также фильтры, строку поиска, поле для сортировки. Выполняются требования к вёрстке +10
2. Карточка товара содержит его изображение, название и т.д., находится ли товар в корзине +10
3. Добавление товаров в корзину +15
  Кликая по карточке с товаром или по кнопке на нем, товар можно добавлять в корзину. Карточки добавленных в корзину товаров внешне отличаются от остальных +10
  На странице отображается количество добавленных в корзину товаров +5
4. Сортировка +20
  Сортируются только те товары, которые в данный момент отображаются на странице:
    сортировка товаров по названию в возрастающем и убывающем порядке +10
    сортировка товаров по цене и рейтингу в возрастающем и убывающем порядке +10
5. Фильтры в указанном диапазоне от и до +10
  фильтры по содержанию +10
6. Фильтры по значению +10
  Выбранные фильтры выделяются стилем.
    фильтры по начинке +5
    можно отобразить только популярные товары +5
7. Можно отфильтровать товары по нескольким фильтрам разного типа +20
  Для нескольких фильтров разного типа отображаются только те товары, которые соответствуют всем выбранным фильтрам.
  Можно отобразить разного содержания товары, например, в двух фильтрах содержится один и тот же товар
  Если товаров, соответствующих всем выбранным фильтрам нет, на странице выводится уведомление "Sorry, no matches found"
8. Сброс фильтров +10
  есть кнопка reset для сброса фильтров, когда не удалось найти товар +5
    Кнопка reset сбрасывает только фильтры, не влияя на порядок сортировки или товары, добавленные в избранное.
    После использования кнопки reset фильтры остаются работоспособными
  при сбросе фильтров кнопкой reset, страница возвращается на исходную позицию +5
9. Сохранение настроек в local storage +30
  выбранные пользователем фильтры, порядок сортировки, добавленные в избранное товары сохраняются при перезагрузке страницы. Есть кнопка сброса настроек, которая очищает local storage +30
10. Поиск +30
  при открытии приложения курсор находится в поле поиска +2
  автозаполнение поля поиска отключено (нет выпадающего списка с предыдущими запросами) +2
  есть placeholder +2
  в поле поиска есть крестик, позволяющий очистить поле поиска +2
  если нет совпадения последовательности букв в поисковом запросе с названием товара, выводится уведомление "Sorry, no matches found" +2
  при вводе поискового запроса на странице остаются только те товары, в которых есть указанные в поиске буквы в указанном порядке. При этом не обязательно, чтобы буквы были в начале слова. Регистр символов при поиске не учитывается +10
  если очистить поле поиска, на странице отображаются товары, соответствующие всем выбранным фильтрам и настройкам сортировки +10`)